import Vue from 'vue'
import Router from 'vue-router'
import store from './stores'

import Login from "@/components/views/Login/Login.vue"
import EsqueciSenha from '@/components/views/EsqueciSenha/EsqueciSenha'
import RedefinirSenha from '@/components/views/RedefinirSenha/RedefinirSenha'
import MasterPage from '@/components/views/MasterPage/MasterPage'
import MasterPageRoutes from '@/components/views/MasterPage/routes.js'
import LoginUtils from '@/util/LoginUtils'
import LoadingScreen from '@/components/commons/LoadingScreen'

Vue.use(Router)

function hasOnlyUtilizacaoMensal() {
  const authorities = store.getters["user/jwt"]?.authorities;
  return (
    Array.isArray(authorities) &&
    authorities.length === 1 &&
    authorities[0] === "ROLE_UTILIZACAO_MENSAL"
  );
}

const routes = [
      {
            name : "Home",
            path : "/",
            component : LoadingScreen,
            beforeEnter () {
                  
                  let defaultPath = '/master-page'

                  if (hasOnlyUtilizacaoMensal()) 
                  {
                        defaultPath = '/master-page/relatorio'
                  }

                  router.replace(LoginUtils.isLogged() ? defaultPath : '/login')
            }
      },
      {
            name : "Login",
            path : "/login",
            component : Login
      },
      {
            name : "EsqueciSenha",
            path : "/esqueci-senha",
            component : EsqueciSenha
      },
      {
            name : "RedefinirSenha",
            path : "/redefinir-senha/:token",
            component : RedefinirSenha
      },
      {
            name : "Master Page",
            path : "/master-page",
            component : MasterPage,
            children : MasterPageRoutes
      },      
      {
            name : "Not Found",
            path : "/*",
            redirect : "/"
      }
]

const router = new Router({ 
      mode: 'history',
      routes 
})

export default router;